module.exports = __webpack_public_path__ + "img/OrgChartTemp3.1a27d42a.png";